import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateDockOperationTypeActions as Actions,
  CreateDockOperationTypeRequestAction as RequestAction,
} from 'store/ducks/dockOperationTypes';

export function* createDockOperationTypeRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `dock-operation-types`, postData);
    onSuccess && onSuccess();
    notify('success', 'Tipo de operação vinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
